import React, { useMemo, useState } from 'react';
import '../../styles/Auction.css';
import DashboardLayout from '../../components/layout/DashboardLayout';
import AuctionSessionList from '../../components/specific/auction/AuctionSessionList';
import AuctionFilters from '../../components/specific/auction/AuctionFilters';
import auctionService from '../../services/auctionService';
import { useInfiniteQuery } from '@tanstack/react-query';
import Button from '../../components/common/Button';

export default function LiveBidSessions() {
    const [statusFilter, setStatusFilter] = useState('active');

    const sessionsQuery = useInfiniteQuery({
        queryKey: ['investor-live-sessions', statusFilter],
        initialPageParam: undefined,
        queryFn: ({ pageParam }) => auctionService.listSessions(statusFilter, { cursor: pageParam, limit: 20 }),
        getNextPageParam: (lastPage) => {
            const pagination = lastPage?.data?.pagination;
            return pagination?.has_more ? pagination?.next_cursor : undefined;
        },
    });

    const sessions = useMemo(() => (
        sessionsQuery.data?.pages?.flatMap((page) => Array.isArray(page?.data?.sessions) ? page.data.sessions : []) || []
    ), [sessionsQuery.data]);

    return (
        <DashboardLayout>
            <div style={{ padding: '1rem' }}>
                <h2 style={{ marginBottom: '1.5rem' }}>Live Auction Sessions</h2>

                <AuctionFilters
                    value={statusFilter}
                    onChange={setStatusFilter}
                />

                {sessionsQuery.isLoading ? (
                    <p>Loading sessions...</p>
                ) : (
                    <>
                        <AuctionSessionList sessions={sessions} />
                        {sessionsQuery.hasNextPage ? (
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                                <Button
                                    variant="secondary"
                                    onClick={() => sessionsQuery.fetchNextPage()}
                                    disabled={sessionsQuery.isFetchingNextPage}
                                >
                                    {sessionsQuery.isFetchingNextPage ? 'Loading...' : 'Load More Sessions'}
                                </Button>
                            </div>
                        ) : null}
                    </>
                )}
            </div>
        </DashboardLayout>
    );
}
